export default "__VITE_ASSET__sTtF2iid__"